import { render, staticRenderFns } from "./authorityAssign.vue?vue&type=template&id=18fbae5e&scoped=true"
import script from "./authorityAssign.vue?vue&type=script&lang=js"
export * from "./authorityAssign.vue?vue&type=script&lang=js"
import style0 from "./authorityAssign.vue?vue&type=style&index=0&id=18fbae5e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18fbae5e",
  null
  
)

export default component.exports